// extracted by mini-css-extract-plugin
export default {"root":"FillPage_root__JtQgA"};